import { isObject, MaterialOrigin, useApiMaterialsV1MaterialOriginsRetrieve } from 'api';
import { capitalizeString } from 'ui';

import { AutocompleteField, AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export const MaterialOriginAutocomplete = (props: Omit<AutocompleteFieldProps<MaterialOrigin>, 'options'>) => {
  const { data, isLoading } = useApiMaterialsV1MaterialOriginsRetrieve();

  return (
    <AutocompleteField<MaterialOrigin>
      options={data?.results?.sort((a, b) => capitalizeString(b.type).localeCompare(capitalizeString(a.type))) || []}
      loading={isLoading}
      getOptionLabel={(option) => {
        if (isObject(option)) {
          return capitalizeString(option.type);
        }
        return '';
      }}
      valueField="id"
      {...props}
    />
  );
};
